import React, { useRef, useState, useEffect, useCallback } from "react";
import Main from "../components/layout/ConsultantMain";
import { Route, Routes, useNavigate } from "react-router-dom";
import Incomingcall from "../pages/consultant/call/Incomingcall";
import { useDispatch } from "react-redux";
import Profile from "../pages/consultant/profile/Profile";
import { useSocket } from "../utils/Socket.Provider";
import ConsultantChatBox from "../pages/consultant/chat/ConsultantChatbox";
import Oncall from "../pages/consultant/call/OnCall";
import {
  useGetConsultantProfileQuery,
  useGetConsultantRoomListQuery,
} from "../redux/rtk/apiRtk";
import { toast, ToastContainer } from "react-toastify";
import EarningsDashboard from "../pages/consultant/earnings/MyEarnings";
import RedeemHistory from "../pages/consultant/redeem/RedeemHistory";
const Consultant = () => {
  const audioRef = useRef(new Audio("/callaudio.mp3"));

  const { data: userList } = useGetConsultantRoomListQuery("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { socket } = useSocket();
  const params = window.location;
  const [showCallNotification, setShowCallNotification] = useState(false);
  const [callData, setCallData] = useState(null);
  const [missedCalls, setMissedCalls] = useState([]);
  const [showMissedCallNotification, setShowMissedCallNotification] =
    useState(false);
  const [currentMissedCall, setCurrentMissedCall] = useState(null);
  const { data: ConsultantProfileData, isLoading } =
    useGetConsultantProfileQuery("");

  useEffect(() => {
    if (userList && userList.length > 0) {
      const rooms = userList.map((i) => i?.roomid);
      socket?.emit("join-chat-room", rooms);
    }
    socket?.on("joinedChatRoom", (data) => {
      console.log("join-chat-room", data);
    });
    return () => {
      socket?.off("join-chat-room");
    };
  }, [userList, socket]);

  // Add custom styles for animations
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes bounce-subtle {
        0%, 20%, 53%, 80%, 100% {
          transform: translate3d(0,0,0);
        }
        40%, 43% {
          transform: translate3d(0,-8px,0);
        }
        70% {
          transform: translate3d(0,-4px,0);
        }
        90% {
          transform: translate3d(0,-2px,0);
        }
      }
      .animate-bounce-subtle {
        animation: bounce-subtle 1s ease-in-out;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  // Function to show the next missed call notification
  const showNextMissedCall = useCallback(() => {
    if (missedCalls?.length > 0) {
      const nextMissedCall = missedCalls[0];
      setCurrentMissedCall(nextMissedCall);
      setShowMissedCallNotification(true);

      // Remove this call from the missed calls list
      setMissedCalls((prev) =>
        prev.filter((call) => call.id !== nextMissedCall.id)
      );
    }
  }, [missedCalls]);
  useEffect(() => {
    // Join room with consultant ID
    if (ConsultantProfileData?._id && socket) {
      socket.emit("join-call-room", ConsultantProfileData._id);

      // Log successful room join for debugging
      console.log("Joined room with ID:", ConsultantProfileData._id);
    }

    // Handle missed call event
    const handleMissedCall = (data) => {
      console.log("Missed call received:", data);

      setShowMissedCallNotification(true);

      // Add the missed call to our list
      setMissedCalls({
        ...data,
        timestamp: new Date(),
        id: Date.now(), // unique ID for this missed call
      });
    };

    if (socket) {
      //   socket.on("end-call", handleEndCall);
      //   socket.on("incoming-call", handleIncomingCall);
      socket.on("missed-call", handleMissedCall);
    }
    return () => {
      if (socket) {
        // socket.off("incoming-call", handleIncomingCall);
        // socket.off("end-call", handleEndCall);
        socket.off("missed-call", handleMissedCall);
        socket.off("consultant-busy");
        socket.off("call-cancelled");
      }
    };
  }, [
    socket,
    ConsultantProfileData,
    dispatch,
    navigate,
    params.hash,
    isLoading,
    missedCalls.length,
    showNextMissedCall,
    showMissedCallNotification,
    showCallNotification,
  ]);

  // Handle dismissing a missed call notification
  const handleDismissMissedCall = () => {
    setShowMissedCallNotification(false);
    setCurrentMissedCall(null);
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    // Show next missed call if there are any
    setTimeout(() => {
      if (missedCalls.length > 0) {
        // showNextMissedCall();
      }
    }, 300);
  };
  return (
    <Main>
      {/* Missed Call Notification */}
      {showMissedCallNotification && missedCalls && (
        <MissedCallNotification
          callerName={missedCalls.name}
          callerImage={missedCalls.profilePic}
          timestamp={missedCalls.timestamp}
          onDismiss={handleDismissMissedCall}
        />
      )}

      <Routes>
        <Route exact path="/" element={<Profile />} />
        <Route exact path="/chats" element={<ConsultantChatBox />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/earnings-dashboard" element={<EarningsDashboard />} />
        <Route path="/redeem-history" element={<RedeemHistory />} />
        <Route
          exact
          path="/incomingcall/:id/:meetingid"
          element={<Incomingcall />}
        />
        <Route exact path="/oncall/:id/:meetingid" element={<Oncall />} />
      </Routes>
      <ToastContainer />
    </Main>
  );
};

// Call notification component with modern light theme styling
export const CallNotification = ({
  callerName,
  callerImage,
  onAccept,
  onReject,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed top-4 right-4 z-[9999] transform transition-all duration-500 ease-out ${
        isVisible
          ? "opacity-100 translate-x-0 scale-100"
          : "opacity-0 translate-x-full scale-95"
      }`}
    >
      <div className="bg-white rounded-xl shadow-lg overflow-hidden w-80 border border-[#A40165]/20 animate-bounce-subtle">
        {/* Top accent bar */}
        <div className="h-1 bg-gradient-to-r from-[#A40165] to-[#8A0154]"></div>

        <div className="p-4">
          <div className="flex items-center">
            {/* Caller image */}
            <div className="relative">
              {callerImage ? (
                <img
                  src={callerImage}
                  alt={callerName}
                  className="w-14 h-14 rounded-full object-cover border-2 border-[#A40165] p-0.5 bg-white"
                />
              ) : (
                <div className="w-14 h-14 rounded-full bg-gray-100 border-2 border-[#A40165] flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-7 w-7 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}

              {/* Status indicator */}
              <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-white animate-pulse"></div>
            </div>

            {/* Caller info */}
            <div className="ml-3 flex-1">
              <h3 className="font-semibold text-gray-800">
                {callerName || "Unknown Caller"}
              </h3>
              <div className="flex items-center">
                <span className="inline-block w-2 h-2 bg-[#A40165] rounded-full mr-2 animate-pulse"></span>
                <p className="text-sm text-gray-600">Incoming call</p>
              </div>
            </div>

            {/* Animated phone icon */}
            <div className="relative w-8 h-8 flex items-center justify-center">
              <div className="w-full h-full rounded-full bg-[#A40165]/20 absolute animate-ping"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-[#A40165]"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
            </div>
          </div>

          {/* Call actions */}
          <div className="mt-4 flex justify-between gap-2">
            <button
              onClick={onReject}
              className="flex-1 py-2.5 px-3 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg flex items-center justify-center transition-all duration-300 hover:shadow"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-1.5 rotate-135 text-red-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              Decline
            </button>
            <button
              onClick={onAccept}
              className="flex-1 py-2.5 px-3 bg-[#A40165] hover:bg-[#8A0154] text-white rounded-lg flex items-center justify-center transition-all duration-300 hover:shadow"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-1.5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Missed call notification component
const MissedCallNotification = ({
  callerName,
  callerImage,
  timestamp,
  onDismiss,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  // Format the timestamp
  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed top-4 right-4 z-[99989] transform transition-all duration-500 ease-out ${
        isVisible
          ? "opacity-100 translate-x-0 scale-100"
          : "opacity-0 translate-x-full scale-95"
      }`}
    >
      <div className="bg-white rounded-xl shadow-lg overflow-hidden w-80 border border-orange-400/20">
        {/* Top accent bar */}
        <div className="h-1 bg-gradient-to-r from-orange-400 to-orange-500"></div>

        <div className="p-4">
          <div className="flex items-center">
            {/* Caller image */}
            <div className="relative">
              {callerImage ? (
                <img
                  src={callerImage}
                  alt={callerName}
                  className="w-14 h-14 rounded-full object-cover border-2 border-orange-400 p-0.5 bg-white"
                />
              ) : (
                <div className="w-14 h-14 rounded-full bg-gray-100 border-2 border-orange-400 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-7 w-7 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}
            </div>

            {/* Caller info */}
            <div className="ml-3 flex-1">
              <h3 className="font-semibold text-gray-800">
                {callerName || "Unknown Caller"}
              </h3>
              <div className="flex items-center">
                <span className="inline-block w-2 h-2 bg-orange-500 rounded-full mr-2"></span>
                <p className="text-sm text-gray-600">
                  Missed call at {formatTime(timestamp)}
                </p>
              </div>
            </div>

            {/* Missed call icon */}
            <div className="w-8 h-8 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-orange-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                <path
                  d="M16 8L8 16M8 8l8 8"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                />
              </svg>
            </div>
          </div>

          {/* Action button */}
          <div className="mt-4 flex justify-end">
            <button
              onClick={onDismiss}
              className="py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg flex items-center justify-center transition-all duration-300 hover:shadow"
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Consultant;
